import { useEffect } from "react";
import { Route, Routes, useLocation } from "react-router-dom";
import { Layout } from "~/components";
import { leaves } from "~/constants";
import { trackFbqPageView } from "~/events";
import { useReferralToken } from "~/features/Referral/useReferralToken";
import { usePrefetch } from "~/hooks/usePrefetch";
import { useScrollToTop } from "~/hooks/useScrollToTop";
import { OnboardingLayout } from "~/OnboardingApp/components";
import { PlanDetailsLayout } from "~/PlanDetailsApp/components";
import { ReactGA } from "~/utils/reactGa";
import { AuthNRoutes } from "./AuthNRoutes";
import { DiagnosticsRoutes } from "./DiagnosticsRoutes";
import { MemberRoutes } from "./MemberRoutes";
import { OnboardingRoutes } from "./OnboardingRoutes";
import { PartnerOnboardingRoutes } from "./PartnerOnboardingRoutes";
import { PlanDetailsRoutes } from "./PlanDetailsRoutes";
import { SharedRoutes } from "./SharedRoutes";
import { lazy, lazyLoadLandingPages } from "./utils";
import { WebflowRoutes } from "./WebflowRoutes";

const NotFoundPage = lazyLoadLandingPages("NotFoundPage");

declare global {
  interface Window {
    getCkyConsent: () => {
      activeLaw: string;
      categories: {
        necessary: boolean;
        functional: boolean;
        analytics: boolean;
        performance: boolean;
        advertisement: boolean;
      };
      isUserActionCompleted: boolean;
      consentID: string;
      languageCode: string;
    };
  }
}

export const AllRoutes = () => {
  const location = useLocation();
  useReferralToken();
  usePrefetch();
  useScrollToTop();

  useEffect(() => {
    ReactGA.send({ hitType: "pageview", page: location.pathname });
  }, [location.pathname]);

  useEffect(() => {
    trackFbqPageView();
  }, [location.pathname]);

  return (
    <Routes>
      <Route
        path={`${leaves.diagnosticsRoot}/*`}
        element={<DiagnosticsRoutes />}
      />
      <Route element={<OnboardingLayout />}>
        <Route
          path={`${leaves.onboardingRoot}/*`}
          element={<OnboardingRoutes />}
        />
      </Route>
      <Route
        path={`${leaves.partnerRoot}/*`}
        element={<PartnerOnboardingRoutes />}
      />
      <Route element={<PlanDetailsLayout />}>
        <Route
          path={`${leaves.planDetailsRoot}/*`}
          element={<PlanDetailsRoutes />}
        />
      </Route>
      <Route element={<Layout />}>
        {WebflowRoutes}
        {SharedRoutes}
        {AuthNRoutes}

        <Route path={`${leaves.memberRoot}/*`} element={<MemberRoutes />} />
        <Route path="*" element={lazy(<NotFoundPage />)} />
      </Route>
    </Routes>
  );
};
